import { autoSyncer } from './autoSyncer.js';

export function addSceneCounter(connectSID, connectIID, iid) {
    const id = 'cnti' + iid;
    const $counterTT = $('.' + id);

    autoSyncer.setGlobal('connectSID', connectSID);
    autoSyncer.setGlobal('connectIID', connectIID);

    autoSyncer.add('scene-counter', id, {
        counter: $counterTT.data('cnt'),
        iid: iid
    }, function (itemData) {
        if (itemData.counterTT) {
            $counterTT.attr('title', itemData.counterTT);
        }
        return false;
    });
}